import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React, { FunctionComponent, ReactNode, useState } from 'react'
// Side effect: configures the career client's baseUrl
import './index'

type Props = {
  children: ReactNode
}

const QueryProvider: FunctionComponent<Props> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
          },
        },
      }),
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export const wrapRootElement = ({ element }: { element: ReactNode }) => (
  <QueryProvider>{element}</QueryProvider>
)

export default QueryProvider
